import { makeStyles } from '@material-ui/styles';
import { Theme } from '@material-ui/core';
import { MOBILE_BREAKPOINT } from '../../../../config/constants';

export const useStyles = makeStyles<Theme>(theme => ({
    modal: {
        backgroundColor: 'white',
        borderRadius: '0.5rem',
        paddingTop: '1rem',
        paddingBottom: '1rem',
        position: 'absolute',
        maxWidth: '1550px',
        width: '100%',
        left: 0,
        right: 0,
        marginLeft: 'auto',
        marginRight: 'auto',
        outline: 'none',
        overflowY: 'auto',
        [theme.breakpoints.down(MOBILE_BREAKPOINT)]: {
            marginTop: '1rem',
        },
        [theme.breakpoints.up(MOBILE_BREAKPOINT)]: {
            marginTop: '3rem',
        },
    },
    modalHeader: {
        borderBottom: '1px solid #dee2e6',
        paddingLeft: '1rem',
        paddingRight: '1rem',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
    modalFooter: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        alignItems: 'center',
        gap: '2rem',
        paddingLeft: '1rem',
        paddingRight: '1rem',
    },
    modalTitle: {
        padding: 0,
        marginBottom: '1rem',
        fontSize: '1rem',
        fontWeight: 400,
        textAlign: 'center',
    },
    modalContent: {
        paddingLeft: '1rem',
        paddingRight: '1rem',
        paddingTop: '1rem',
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        alignContent: 'center',
        alignItems: 'center',
        justifyItems: 'center',
        justifyContent: 'center',
    },
    avatar: {
        marginRight: '28px',
        width: '40px',
        height: '40px',
        borderRadius: '50%',
    },
    name: {
        fontSize: '18px',
        fontWeight: 600,
        marginLeft: '-1rem',
    },
    copyLinkBox: {
        background: '#f3f3f3',
        cursor: 'text',
        borderRadius: '15px',
        padding: '10px 15px',
        width: '2rem',
        marginBottom: '2rem',
        marginTop: '0.6rem',
    },
    text: {
        fontSize: '1rem',
        fontWeight: 400,
    },
    eventTimeIcon: {
        height: '14px',
    },
    eventTimeText: {
        color: 'rgb(122, 120, 131)',
        fontSize: '20px',
        fontWeight: 600,
        marginLeft: '0.5rem',
    },
    coverImage: {
        maxWidth: '100%',
        maxHeight: '100%',
        borderRadius: '1rem',
    },
    leftColumn: {
        [theme.breakpoints.up(MOBILE_BREAKPOINT)]: {
            paddingLeft: '1rem',
        },
    },
    rightColumn: {
        [theme.breakpoints.down(MOBILE_BREAKPOINT)]: {
            paddingTop: '1.5rem',
        },
        [theme.breakpoints.up(MOBILE_BREAKPOINT)]: {
            paddingLeft: '1rem',
        },
    },
    title: {
        marginBottom: '0.5rem',
        marginTop: '1rem',
        fontSize: '1.85rem',
        fontWeight: 500,
    },
    description: {
        marginTop: '0.25rem',
        marginBottom: '0.5rem',
        fontSize: '1.25rem',
        fontWeight: 400,
    },
    userAvatar: {
        borderRadius: '50%',
        border: `1.5px solid ${theme.palette.primary.main}`,
        alignSelf: 'center',
        width: '65px',
        height: '65px',
        objectFit: 'cover',
        padding: '2px',
    },
    day: {
        fontSize: '3.5rem',
        fontWeight: 600,
        lineHeight: 1,
    },
    month: {
        color: theme.palette.primary.main,
        fontSize: 22,
        fontWeight: 600,
    },
    userName: {
        fontSize: '1.5rem',
        fontWeight: 500,
    },
    star: {
        height: '1rem',
    },
    nameAndRatingGridItem: {
        display: 'flex',
        flexDirection: 'column',
        paddingLeft: '2rem',
        justifyContent: 'center',
    },
    avatarGridItem: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
    },
}));
